const sites = [
    {
        id: 1,
        name: 'virtual-herbal-garden',
        description: 'Virtual Herbal Garden',
        url: 'https://ub-vhg.vercel.app',
        icon: '🌿'
    },
    {
        id: 2,
        name: 'bat-chat',
        description: 'Bat Chat',
        url: 'https://ubbatchat.vercel.app',
        icon: '🦇'
    },
    {
        id: 3,
        name: 'ub-qr',
        description: 'UB QR',
        url: 'https://ub-qr.vercel.app',
        icon: '🔲'
    },
    {
        id: 4,
        name: 'pesu-attd',
        description: 'PESU Attendance',
        url: 'https://pesu-attd.vercel.app',
        icon: '📅'
    },
    {
        id: 5,
        name: 'ub-portfolio-2-0',
        description: 'UB Portfolio 2.0',
        url: 'https://ub-portfolio-2-0.vercel.app',
        icon: '🧩'
    },
    {
        id: 6,
        name: 'txt-to-voice',
        description: 'Text to Voice (ub-speech)',
        url: 'https://ub-speech.vercel.app',
        icon: '🔊'
    },
    {
        id: 7,
        name: 'ub-portfolio',
        description: 'UB Portfolio (uselessbruh)',
        url: 'https://uselessbruh.vercel.app',
        icon: '🖼️'
    },
    {
        id: 8,
        name: 'ub-weather',
        description: 'UB Weather',
        url: 'https://ub-weather.vercel.app',
        icon: '⛅'
    }
];

export default sites;
